<mat-drawer-container hasBackdrop="false" class="d-md-flex d-lg-none">
  <mat-drawer #drawer mode="over">
    <app-overview-filter-menu (inputValuesChange)="onInputValuesChange($event)"></app-overview-filter-menu>
  </mat-drawer>
  <mat-drawer-content>
    <ul *ngIf="events && getFilteredEvents().length > 0; else noEvents" class="event-list">
      <li *ngFor='let event of getFilteredEvents()' class="event-container">
        <div class="img-container-overview" [ngStyle]="{'background-image': 'url(' + event.images[0] + ')'}" (click)="redirectToEvent(event.id)">
          <div class="tag {{ event.category | lowercase }}">
            <img src="assets/img/icons/{{ event.category | lowercase }}.svg" alt="">
          </div>
        </div>
        <div class="event-content">
          <div class="event-info">
            <p class="event-details">
              <i class="bi bi-calendar icon"></i> {{ event.start.toMillis() | date:'d MMM' }}
              <span class="separator"> | </span>
              van {{ event.start.toMillis() | date:'H:mm' }}&nbsp;tot
              <span *ngIf="eventDateTime(event)">{{ event.end.toMillis() | date:'d MMM H:mm' }}</span>
              <span *ngIf="!eventDateTime(event)">{{ event.end.toMillis() | date:'H:mm' }}</span>
              <span class="separator"> | </span>
              <i class="bi bi-geo-alt icon"></i> {{ event.address.location }}
            </p>
            <a class="event-title" [routerLink]="['/activiteit', event.id]">{{ event.name }}</a>
            <p class="event-description">{{ event.description }}</p>
            <button class="members-button" (click)="redirectToEventSignees(event.id)">Aangemelde leden bekijken</button>
            <button class="event-button" (click)="redirectToEvent(event.id)">Activiteit bekijken</button>
          </div>
        </div>
      </li>
    </ul>
    <ng-template #noEvents>
      <div class="w-75 mx-auto">
        <h2>Geen resultaten gevonden</h2>
        <b>We hebben helaas geen resultaten gevonden met je huidige filterinstellingen. Pas je filterinstellingen aan, of zoek met een andere term.</b>
        <br>
        <br>
        <h3>Wat nu?</h3>
        <ul>
          <li>Probeer andere filterinstellingen.</li>
          <li>Gebruik een andere zoekterm, indien je die hebt gebruikt.</li>
          <li>Stel je vraag aan ons! Wij helpen je graag verder.</li>
        </ul>
        <p>Als je hier een resultaat had verwacht en zeker weet dat je de correcte filterinstellingen hebt ingevuld, neem dan gerust contact met ons op en wellicht kunnen we je verder helpen!</p>
      </div>
    </ng-template>
  </mat-drawer-content>
</mat-drawer-container>

<main class="container-fluid main-container my-5 d-none d-lg-flex" *ngIf="organization">
  <h1 class="subtitle">Activiteiten van {{ organization.name }}</h1>
  <a class="text-decoration-none back-link" routerLink="../"><i class="bi bi-arrow-left me-2"></i>Vorige pagina</a>
  <app-overview-filter-menu (inputValuesChange)="onInputValuesChange($event)"></app-overview-filter-menu>
  <hr>
  <ul *ngIf="events && getFilteredEvents().length > 0; else noEvents" class="event-list">
    <li *ngFor='let event of getFilteredEvents()' class="event-container">
      <div class="img-container-overview" [ngStyle]="{'background-image': 'url(' + event.images[0] + ')'}" (click)="redirectToEvent(event.id)">
        <div class="tag {{ event.category | lowercase }}">
          <img src="assets/img/icons/{{ event.category | lowercase }}.svg" alt="">
        </div>
      </div>
      <div class="event-content">
        <div class="event-info">
          <p class="event-details">
            <i class="bi bi-calendar icon"></i> {{ event.start.toMillis() | date:'d MMM' }}
            <span class="separator"> | </span>
            van {{ event.start.toMillis() | date:'H:mm' }}&nbsp;tot
            <span *ngIf="eventDateTime(event)">{{ event.end.toMillis() | date:'d MMM H:mm' }}</span>
            <span *ngIf="!eventDateTime(event)">{{ event.end.toMillis() | date:'H:mm' }}</span>
            <span class="separator"> | </span>
            <i class="bi bi-geo-alt icon"></i> {{ event.address.location }}
          </p>
          <a class="event-title" [routerLink]="['/activiteit', event.id]">{{ event.name }}</a>
          <p class="event-description">{{ event.description }}</p>
          <button class="members-button" (click)="redirectToEventSignees(event.id)">Aangemelde leden bekijken</button>
          <button class="event-button" (click)="redirectToEvent(event.id)">Activiteit bekijken</button>
        </div>
      </div>
    </li>
  </ul>
  <ng-template #noEvents>
    <div class="error-container">
      <h2>Geen resultaten gevonden</h2>
      <b>We hebben helaas geen resultaten gevonden. Dit kan komen doordat je nog geen activiteiten hebt geplaatst of door de gebruikte filterinstellingen!</b>
      <br>
      <br>
      <h3>Wat nu?</h3>
      <ul>
        <li>Maak een activiteit aan door rechtsboven naar activiteit plaatsen te gaan.</li>
        <li>Probeer andere filterinstellingen.</li>
        <li>Gebruik een andere zoekterm, indien je die hebt gebruikt.</li>
        <li>Stel je vraag aan ons! Wij helpen je graag verder.</li>
      </ul>
      <p>Als je hier een resultaat had verwacht en zeker weet dat je de correcte filterinstellingen hebt ingevuld, neem dan gerust contact met ons op en wellicht kunnen we je verder helpen!</p>
    </div>
  </ng-template>
</main>
